/* The cover art a Hero can show. Kept apart from Hero so a screen that lazy-loads the
   component can name a cover without pulling the component into its own chunk. */
export enum HeroCover {
  Mountain = 'mountain',
  Map = 'map',
  Swish = 'swish',
  Bushveld = 'bushveld',
  SunsetField = 'sunsetField',
  /** The stretchable swish the scene covers blend with; not a cover on its own. */
  SceneSwish = 'sceneSwish',
}
